<template>
    <div class="footer">
        <div class="center-banner">
            <div class="footer_top">
                <div class="footer_left">
                    <img src="../assets/img/logo.png" />
                    <div class="ul">
                        <div>
                            <h6 @click="goto('/cooperation')">合作入驻</h6>
                            <p @click="goto('/cooperation')">商家入驻</p>
                            <p @click="goto('/cooperation')">代运营服务商入驻</p>
                            <p @click="goto('/problem')"> 常见问题</p>
                        </div>
                        <div @click="goto('/user')">
                            <h6>关于我们</h6>
                            <p>超拼简介</p>
                            <p> 核心团队</p>
                            <p>发展大事记</p>
                            <p>社会荣誉</p>
                        </div>
                        <div @click="goto('/wanted')">
                            <h6>加入超拼</h6>
                            <p>人才招聘</p>
                            <p>简历投递</p>
                        </div>
                        <div >
                            <h6>友情链接</h6>
                            <p><a href="https://union.chaopin100.com/index" target="_blank">超拼联盟</a></p>
                            <p><a href="https://www.chaopinkj.com/" target="_blank">超拼科技</a></p>
                            <p><a href="https://www.yuanzhigroup.cn/" target="_blank">缘智集团</a></p>
                        </div>
                    </div>

                </div>
                <div class="footer_right">
                    <div>
                        <div>
                            <h6>客服电话</h6>
                            <p>{{ data.phone }}</p>
                        </div>
                        <div>
                            <h6>企业邮箱</h6>
                            <p>{{ data.qqEmail }}</p>
                        </div>
                    </div>
                    <div>
                        <img :src="data.appCode" />
                        <img :src="data.appletCode" />
                    </div>

                </div>

            </div>
            <div class="footer_bottom">
                <p class="flex_center"><a href="https://beian.miit.gov.cn" target="_blank">{{ data.numRecord }}</a> &nbsp;&nbsp;&nbsp;&nbsp;<img
                        src="../assets/img/foo_icon.png" />&nbsp;&nbsp;&nbsp;&nbsp;{{ data.recordPublic }}</p>
                <div v-html="data.information" class="footer_bottom"
                    style="display: flex;flex-wrap: wrap; align-items: center;"></div>
                <!-- <p>药品网络交易第三方平台备案信息 营业执照 互联网药品信息服务资格证（编号(陕)-经营性-2020-0052） 食品经营许可证 广播电视节目制作经营许可证 中华人民共和国增值电信业务经营许可证
                    中华人民共和国增值电信业务经营许可证(附件)
                    计算机软件著作权登记证书 网络文化经营许可证 基本存款信息证明 医疗器械网络交易服务第三方平台备案凭证（编号(陕)网械平台备字(2020)第00003号） 陕西省网络食品交易平台备案凭证
                    (编号:陕网食备110035)

                </p> -->
                <p>
                    Copyright 2019-2025 陕西超拼网网络科技有限公司 版权所有
                </p>

            </div>
        </div>
    </div>
</template>

<script>
import { reactive, ref, toRefs, } from "@vue/reactivity";
import { useRouter } from 'vue-router';
import { getconfig } from '@/comm/api'
import { onMounted } from "vue";


export default {
    name: "myFooter",
    setup() {
        const router = useRouter()
        let data = reactive({
            qqEmail: '',
            phone: '',
            appletCode: '',
            appCode: '',
            appExtend: '',
            recordPublic: '',
            userProtocol: '',
            chaoPinLink: '',
            numRecord: '',
            chaoPinWang: '',
            information: ""
        });
        const goto = (path) => {
            router.push(path)
        }
        const getconfigFn = async (configName,) => {
            try {
                const res = await getconfig({ configName: configName });
                console.log(1, res);
                if (res.code == 1) {
                    data[configName] = res.data
                    if(configName=='information'){
                        data.information =  addStyleToTag(data.information,'a','text-decoration: none')
                    }
                }
            } catch (err) {
                console.error("失败", err);

            }
        };
        const addStyleToTag = (inputString, tagName, style) => {
            // 使用正则表达式匹配tagName标签
            const regex = new RegExp(`<${tagName}>(.*?)<\/${tagName}>`, 'g');
            let match;
            let outputString = inputString;
            while ((match = regex.exec(inputString)) !== null) {
                // 获取标签内的内容
                const tagContent = match[1];
                // 添加样式
                const replacedTag = `<${tagName} style='${style}'>${tagContent}</${tagName}>`;
                // 替换原来的标签
                outputString = outputString.replace(match[0], replacedTag);
            }
            console.log(match,'matchmatchmatch')
            return outputString;
        }
        onMounted(() => {
            getconfigFn('qqEmail')
            getconfigFn('appletCode')
            getconfigFn('appCode')
            getconfigFn('appExtend')
            getconfigFn('recordPublic')
            getconfigFn('numRecord')
            getconfigFn('phone')
            getconfigFn('information')
        })
        return {
            goto,
            data,
            getconfigFn,
            addStyleToTag
        }
    }
}
</script>

<style lang="scss" scoped>
.footer {
    height: 400px;
    background: #1C1C1C;

    .footer_top {
        border-bottom: 1px solid #42454C;
        display: flex;
        padding-top: 40px;
        padding-bottom: 40px;
        justify-content: space-between;

        h6 {
            font-weight: 400;
            font-size: 16px;
            color: #FFFFFF;
            padding-bottom: 10px;
        }

        .footer_left {
            display: flex;
            width: 50%;

            img {
                width: 100px;
                height: 30px;
            }

            .ul {
                width: 80%;
                display: flex;
                justify-content: space-evenly;
                cursor: pointer;

                p {
                    font-family: Microsoft YaHei;
                    font-weight: 400;
                    font-size: 13px;
                    color: #747474;
                    padding-bottom: 10px;
                    cursor: pointer;
                }

            }
        }

        .footer_right {
            display: flex;
            width: 50%;
            justify-content: space-around;

            p {
                font-family: Microsoft YaHei;
                font-weight: 400;
                font-size: 13px;
                color: #747474;
                padding-bottom: 10px;
            }

            img {
                margin-left: 30px;
                width: 100px;
            }
        }
    }

    .footer_bottom {
        margin-top: 10px;
        text-align: center;
        font-family: Microsoft YaHei;
        font-weight: 300;
        font-size: 10px;
        color: #747474 !important;
        line-height: 18px;
        cursor: pointer;
        text-decoration: none !important;
    }
}

.footer_bottom :deep(a) {
    // margin-top: 10px;
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: 300;
    font-size: 10px;
    color: #747474;
    line-height: 18px;
    cursor: pointer;
    text-decoration: none;
}

.center-banner {
    width: 1200px;
    margin: 0px auto;
}

.flex_center {
    display: flex;
    align-items: center;
    justify-content: center;
}
a{
    text-decoration: none; /* 去掉下划线 */
    color: inherit; /* 继承父元素的颜色，或者设置为其他你需要的颜色 */
}
</style>
<style >
.footer_bottom>p>a {
    /* margin-top: 10px; */
    text-align: center;
    font-family: Microsoft YaHei;
    font-weight: 300;
    font-size: 10px;
    color: #747474;
    line-height: 18px;
    cursor: pointer;
    text-decoration: none;
}
</style>